import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Nav } from "react-bootstrap";

const SetButtonValueModal = ({ show, onHide }) => {

    const [activeTab, setActiveTab] = useState("game");

    const [gameButtons, setGameButtons] = useState([
        { label: "1k", value: "1000" },
        { label: "2k", value: "2000" },
        { label: "5k", value: "5000" },
        { label: "10k", value: "10000" },
        { label: "20k", value: "20000" },
        { label: "25k", value: "25000" },
        { label: "50k", value: "50000" },
        { label: "75k", value: "75000" },
        { label: "90k", value: "90000" },
        { label: "95k", value: "95000" },
    ]);

    const [casinoButtons, setCasinoButtons] = useState([
        { label: "100", value: "100" },
        { label: "500", value: "500" },
        { label: "1k", value: "1000" },
        { label: "2k", value: "2000" },
        { label: "5k", value: "5000" },
    ]);

    const handleGameChange = (index, field, value) => {
        const updated = [...gameButtons];

        updated[index][field] = value;

        setGameButtons(updated);
    };

    const handleCasinoChange = (index, field, value) => {
        const updated = [...casinoButtons];

        updated[index][field] = value;

        setCasinoButtons(updated);
    };

    const handleUpdate = () => {

        const data = {
            gameButtons,
            casinoButtons
        };

        console.log("Updated Button Values:", data);

        // API call can be added here
        // axios.post("/api/button-values", data);

        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            scrollable
            size="md"
            className="set-button-modal"
        >

            {/* Header */}
            <Modal.Header closeButton style={{ backgroundColor: "#0088cc", borderRadius: "0px", width: "100%", }}>
                <Modal.Title>
                    Set Button Value
                </Modal.Title>
            </Modal.Header>

            {/* Tabs */}
            <div className="modal-tabs">

                <Nav variant="tabs">

                    <Nav.Item>
                        <Nav.Link
                            active={activeTab === "game"}
                            onClick={() => setActiveTab("game")}
                            style={{ backgroundColor: "#2c3e50", borderRadius: "0px" }}
                        >
                            Game Buttons
                        </Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link
                            active={activeTab === "casino"}
                            onClick={() => setActiveTab("casino")}
                            style={{ backgroundColor: "#cccccc", borderRadius: "0px" }}
                        >
                            Casino Buttons
                        </Nav.Link>
                    </Nav.Item>

                </Nav>

            </div>

            {/* Body */}
            <Modal.Body style={{ backgroundColor: "#fff", overflowX: "hidden" }}>

                {activeTab === "game" && (

                    <div>

                        {/* Table Heading */}
                        <Row className="button-heading mb-2">

                            <Col xs={6} className="mb-0">
                                <strong className="fw-semibold" style={{ fontSize: "16px" }}>Price Label:</strong>
                            </Col>

                            <Col xs={6} className="mb-0">
                                <strong className="fw-semibold" style={{ fontSize: "16px" }}>Price Value:</strong>
                            </Col>

                        </Row>

                        {/* Inputs */}
                        {gameButtons.map((item, index) => (
                            <>
                                <Row
                                    className="button-row"
                                    key={index}
                                >

                                    <Col xs={6} className="mb-0">

                                        <Form.Control
                                            type="text"
                                            value={item.label}
                                            onChange={(e) =>
                                                handleGameChange(
                                                    index,
                                                    "label",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </Col>

                                    <Col xs={6} className="mb-0">

                                        <Form.Control
                                            type="number"
                                            value={item.value}
                                            onChange={(e) =>
                                                handleGameChange(
                                                    index,
                                                    "value",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </Col>

                                </Row>
                            </>

                        ))}

                        <Button
                            className="update-btn w-50"
                            onClick={handleUpdate}
                        >
                            Update
                        </Button>

                    </div>

                )}

                {activeTab === "casino" && (

                    <div>

                        <Row className="button-heading mb-2">

                            <Col xs={6} className="mb-0">
                                <strong>Price Label:</strong>
                            </Col>

                            <Col xs={6} className="mb-0">
                                <strong>Price Value:</strong>
                            </Col>

                        </Row>

                        {casinoButtons.map((item, index) => (
                            <>
                                <Row
                                    className="button-row"
                                    key={index}
                                >

                                    <Col xs={6} className="mb-0">

                                        <Form.Control
                                            type="text"
                                            value={item.label}
                                            onChange={(e) =>
                                                handleCasinoChange(
                                                    index,
                                                    "label",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </Col>

                                    <Col xs={6} className="mb-0">

                                        <Form.Control
                                            type="number"
                                            value={item.value}
                                            onChange={(e) =>
                                                handleCasinoChange(
                                                    index,
                                                    "value",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </Col>

                                </Row>
                            </>

                        ))}

                        <Button
                            className="update-btn w-50"
                            onClick={handleUpdate}
                        >
                            Update
                        </Button>

                    </div>

                )}

            </Modal.Body>

        </Modal>
    );
};

export default SetButtonValueModal;